// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1Q4h5","itemTitle":"ClientEmergencyInfo_itemTitle__1q8P5","itemText":"ClientEmergencyInfo_itemText__1wVnv"};